import { pdfjs } from 'react-pdf';

// UploadField sets this too; set it here as well so the check works wherever it's imported.
if (!pdfjs.GlobalWorkerOptions.workerSrc) {
  pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();
}

// One check per File: AntD fires onChange once per selected file with the growing list, so the
// same files are checked repeatedly within a single selection.
const passwordCheckCache = new WeakMap();

// Resolves true only for PDFs that need a password to open. PDFs that only restrict printing or
// editing (owner password) open normally and resolve false, as do non-PDFs and unreadable files
// (format/size validation reports those).
export const isPasswordProtectedPdf = (file) => {
  if (!file || file.type !== 'application/pdf') {
    return Promise.resolve(false);
  }
  if (!passwordCheckCache.has(file)) {
    const check = file
      .arrayBuffer()
      .then((data) => {
        const loadingTask = pdfjs.getDocument({ data });
        return loadingTask.promise.then(
          () => {
            loadingTask.destroy();
            return false;
          },
          (error) => {
            loadingTask.destroy();
            return error?.name === 'PasswordException';
          },
        );
      })
      .catch(() => false);
    passwordCheckCache.set(file, check);
  }
  return passwordCheckCache.get(file);
};
